export const constructFilterItemKey = (
    filter: string,
    filterItemValue: string,
    isMobile: boolean,
): string => {
    return `${filter}-${filterItemValue}-${isMobile ? 'mobile' : 'desktop'}`;
};
